export interface Session {
  session_id: number;
  name: string;
  code: string;
  alias: string;
  commnet: string;
  digit_code: string;
  is_active: boolean;
}

export interface SessionCollection extends Session {}

export interface Subject {
  subject_id: number;
  name: string;
  code: string;
  alias: string;
  commnet: string;
  digit_code: string;
  is_active: boolean;
}

export interface SubjectCollection extends Subject {}

export interface Procedure {
  procedure_id: number;
  name: string;
  code: string;
  alias: string;
  commnet: string;
  digit_code: string;
  is_active: boolean;
  subject_id: number;
  session_id: number;
}

export interface ProcedureCollection extends Procedure {}

export interface CollectorPublication {
  publication_id: number;
  name: string;
  scan_bo1: boolean;

  created_at: string;
  updated_at: string;

  start_at: string;
  end_at: string;
  published_at: string;
  active_end_at: string;
  active_start_at: string;
  subject_name: string;
  session_course: string;
  subject_digit_code: string;
  session_digit_code: string;
  participants_count: number;
  procedure_type: string;
}

export interface CollectorPublicationCollection extends CollectorPublication {}

export const enum KimUserStatus {
  done = 'DONE',
  to_do = 'TO_DO',
  error = 'ERROR',
  pending = 'PENDING',
  in_progress = 'IN_PROGRESS',
}

export const enum CollectorTaskStatus {
  pending = 'pending',
  in_progress = 'in_progress',
  done = 'done',
  error = 'error',
}

export interface KimUser {
  kim_user_id: number;
  status: KimUserStatus;
  username: string;
  target_count: number;
  generated_count: number;
  publication_dat: number;
  kims: unknown;
}

export interface KimUserCollection extends KimUser {}

export interface KimVariant {
  kim_variant_id: number;
  original_variant: number;
  total_tasks_count: number;
  not_null_tasks_count: number;
}

export interface KimVariantCollection extends KimVariant {}
